const { Component, render } = wp.element;

import { SliderBerg_Slider as Slider } from './slider.js';
import {
  SliderBerg_isset as isset,
  SliderBerg_GoogleFontLoader as GoogleFontUploader
} from './utils.js';

// Instantiate for every carousel on page
document.addEventListener('DOMContentLoaded', function(event) {
  const sliders = document.querySelectorAll('.SliderBerg-wrapper');
  for (let i = 0; i < sliders.length; i++) {
    let attributes = JSON.parse(sliders[i].getAttribute('data-attributes'));
    console.log(attributes);
    const {
      autoplay,
      show_pag,
      show_nav,
      show_text,
      autoplay_speed,
      pag_bg_color,
      pag_color,
      text_bg_color,
      text_color,
      text_align,
      text_size,
      text_font,
      slider_height,
      autostop,
      items,
      main_text_size
    } = attributes;

    if (isset(attributes, 'text_font')) {
      GoogleFontUploader(text_font);
    }

    render(
      <Slider
        options={{
          slide_timeout: autoplay_speed * 1000,
          autoplay: autoplay,
          show_nav: show_nav,
          show_pag: show_pag,
          show_text: show_text,
          pag_bg_color: pag_bg_color,
          pag_color: pag_color,
          text_bg_color: text_bg_color,
          text_color: text_color,
          text_align: text_align,
          slider_height: slider_height,
          autostop: autostop,
          text_size: text_size,
          text_font: text_font,
          main_text_size: main_text_size
        }}
        items={items}
        where="frontend"
      />,
      sliders[i]
    );

    console.log('%c players present on page and running...', 'color: #9C27B0');
  }
});



// WEBPACK FOOTER //
// ./src/js/frontend.js